module.exports = __webpack_public_path__ + "static/img/gengduo.91a5d905.jpg";